<template>
  <div id="analysis-table-container">
    <table class="analysis-table-line sticky" :class="[type, { 'bottom-line': !tableDatas.length }, { fixed: false }]">
      <thead>
        <tr class="none-line" :class="[{ country: 'country', year: 'year' }[dataType], { long: option.index.width === 88 }]">
          <th v-if="onSelected" class="selected" :width="'auto'">
            <div class="col-block">
              <div :style="{ flex: 1 }"></div>
              <label :for="'select-all-' + dataType">
                <div v-html="'選擇'"></div>
                <input type="checkbox" :id="'select-all-' + dataType" v-show="false" v-model="[...selected].length" @change="e => selected = e.target.checked ? tableDatas : []" />
                <img :src="require('../../assets/images/checkbox-' + ([...selected].length ? [...selected].length < tableDatas.length ? 'minus' : 'true' : 'false') + '.svg')">
              </label>
              <div :style="{ flex: 1 }"></div>
            </div>
          </th>
          <th v-if="dataType === 'country'" :style="{ width: option.index.width + 'px', minWidth: option.index.width + 'px', maxWidth: option.index.width + 'px' }">
            <div class="row-block">
              <div :style="{ flex: 1 }"></div>
              <div>排名</div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </th>
          <th :style="{ width: { country: option.country.width, year: option.year.width }[dataType] + 'px', minWidth: { country: option.country.width, year: option.year.width }[dataType] + 'px', maxWidth: { country: option.country.width, year: option.year.width }[dataType] + 'px' }">
            <div class="row-block">
              <div :style="{ flex: 1 }"></div>
              <div>{{ { country: option.country.title, year: option.year.title }[dataType] }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </th>
          <th v-for="(content, index) in option.contents" :key="index" :width="'auto'" :style="{ 'z-index': option.contents.length - index }">
            <div class="row-block">
              <div :style="{ flex: 1 }"></div>
              <div v-html="content.title.join('<br>')"></div>
              <template v-if="content.description || content.alert">
                <div :style="{ width: '5px' }"></div>
                <div class="info-icon-container">
                  <img class="info-icon" :src="require('../../assets/images/title-info-icon.svg')">
                  <div class="info-container">
                    <span class="info-bor-cor"></span>
                    <div class="info-block col-block default-shadow">
                      <div class="description" v-if="content.description">
                        <div class="title">{{ content.description.title + ':' }}</div>
                        <div class="content">{{ content.description.content }}</div>
                      </div>
                      <div v-if="content.description && content.alert" :style="{ height: '5px' }"></div>
                      <div class="alert" v-if="content.alert">
                        <div class="title">{{ content.alert.title }}</div>
                        <div class="content">{{ content.alert.content }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div :style="{ flex: 1 }"></div>
            </div>
          </th>
          <th :width="'auto'" v-if="option.contents.length" :style="{ width: '120px', minWidth: '120px', maxWidth: '120px' }">
            <div class="row-block">
              <div :style="{ flex: 1 }"></div>
              <center
                v-html="{
                  country: [
                    '分數總計'
                  ],
                  year: [
                    '標準化總分之',
                    '世界總排名'
                  ]
                }[dataType].join('<br>')"
              ></center>
              <div :style="{ flex: 1 }"></div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(data, dindex) in tableDatas">
          <tr class="none-line" :class="[{ country: 'country', year: 'year' }[dataType], { long: option.index.width === 88 }]" :key="dindex * 2">
            <td v-if="onSelected" class="selected" rowspan="2">
              <label :for="'selected' + dataType + dindex">
                <input type="checkbox" :id="'selected' + dataType + dindex" v-show="false" :value="data" v-model="selected" />
                <img :src="require('../../assets/images/checkbox-' + (selected.includes(data) ? 'true' : 'false') + '.svg')">
              </label>
            </td>
            <td class="table-content ranking" :class="{ description: data.display_description }" v-if="dataType === 'country'" rowspan="2">
              <div class="col-block">
                <div :style="{ flex: 1 }"></div>
                <div>{{ selected.includes(data) ? dindex + 1 : '--' }}</div>
                <div class="description" v-if="data.display_description">
                  <borCor
                    v-if="data.display_description"
                    :width="'180px'"
                    :type="!dindex ? 'bottom' : 'top'"
                    :background="'#FFFCEF'"
                    :border="'transparent'"
                    :blockStyle="{
                      'padding': '10px',
                      'font-size': '12px',
                      'font-weight': '400',
                      'text-align': 'left',
                      'line-height': '18px'
                    }"
                  >
                    <div slot="trigger">
                      <div class="img-container center-block">
                        <img :src="require('../../assets/images/taiwan-alert-icon.svg')" alt="">
                      </div>
                    </div>
                    <div class="content" slot="content">
                      <div class="text" v-html="data.display_description"></div>
                    </div>
                  </borCor>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </td>
            <td rowspan="2">
              <div
                class="table-content"
                :class="[{ country: 'country', year: 'year' }[dataType]]"
                v-html="{
                  country: [
                    data[option.country.name],
                    data[option.country.subName]
                  ],
                  year: [
                    data[option.year.name]
                  ]
                }[dataType].join('<br>')"
                @click="e => $emit({ country: 'countryOnClick', year: 'yearOnClick' }[dataType], data)"
              >
              </div>
              <div v-if="dataType === 'country' && data.hasReport" class="report-icon" @click="e => $emit('reportOnClick', data)">
                <img :src="require('../../assets/images/table-report-icon.svg')" alt="">
              </div>
            </td>
            <td v-for="(content, oindex) in option.contents" :key="oindex">
              <span class="table-content">{{ (content.display || (x => x))(data[content.value]) || 'n/a' }}</span>
            </td>
            <td class="table-content total" v-if="option.contents.length" rowspan="2">
              <div>{{ { country: toPriceString(data['display_total_standardization'].toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: data['total_standardization_order'] }[dataType] }}</div>
            </td>
          </tr>
          <tr class="none-line" :class="[{ country: 'country', year: 'year' }[dataType]]" :key="dindex * 2 + 1">
            <td v-for="(content, oindex) in option.contents" :key="oindex">
              <span class="table-content">{{ (content.subDisplay || (x => x))({ country: data.display_standardization[content.value], year: data.standardization[content.value + '_order'] }[dataType]) || { country: 0, year: 'n/a' }[dataType] }}</span>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import borCor from '../../components/tool/borCor'
import { toPriceString } from '../../constants/global/util'

export default {
  components: {
    borCor
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    datas: {
      type: Array,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: () => 'table'
    },
    init: {
      type: Array,
      default: () => []
    },
    onSelected: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      selected: []
    }
  },
  computed: {
    tableDatas () {
      let tableDatas = this.datas
      return tableDatas
    },
    // global
    toPriceString () { return toPriceString }
  },
  created () {
    this.selected = this.init
  },
  watch: {
    'init' () {
      this.selected = this.init
    },
    'selected' () {
      this.onSelected(this.selected)
    }
  },
  methods: {
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 2
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.$emit('onSort', this.sort)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#analysis-table-container
  width: 100%
  table
    width: 100%
    .required
      color: #EA5514
      padding-left: 1px
    .selected
      padding: 0
      text-align: center
      label
        padding: 15px 20px
        cursor: pointer
        input
          cursor: pointer
        img
          margin: 5px 0 0
          background: white
          border-radius: 2px
    .table-content
      white-space: pre-wrap
      &.country
        text-align: center
        color: #3966A6
        font-weight: bold
        text-decoration: underline
        cursor: pointer
      &.year
        text-align: center
        color: #707070
        font-weight: bold
      &.ranking
        text-align: center
        color: #707070
        font-weight: bold
        &.description
          z-index: 10
        .description
          position: absolute
          margin-left: 35px
          margin-top: 4px
          .bor-cor
            display: flex
            .trigger
              img
                width: 12px
                height: 12px
      &.total
        text-align: center
    .report-icon
      display: flex
      position: absolute
      top: 28px
      right: 15px
      cursor: pointer
    tr
      th
        color: white
        .info-icon-container
          position: relative
          margin-top: 2px
          .info-icon
            width: 12px
            height: 12px
            cursor: pointer
            &:hover
              & + div
                opacity: 1
                top: 28px
          .info-container
            position: absolute
            top: -9999999999999999999px
            left: -8px
            opacity: 0
            transition: opacity .5s ease
            z-index: 10
            &:hover
              opacity: 1
              top: 28px
            .info-bor-cor
              width: 0
              height: 0
              font-size: 0
              border-width: 11px 6px
              border-style: solid
              border-color: transparent transparent white
              overflow: hidden
              position: absolute
              left: 8px
              top: -22px
              cursor: pointer
            .info-block
              width: 200px
              padding: 10px
              background: white
              font-size: 12px
              color: #555555
              box-sizing: border-box
              border-radius: 3px
              white-space: pre-line
              align-items: flex-start
              .description
                .title
                  font-weight: bold
                  margin-bottom: 3px
                .content
                  font-weight: 400
              .alert
                & > div
                  display: inline
                .title
                  color: #ea1414
                  font-weight: bold
                  margin-right: 0
                .content
                  font-weight: 400
      td
        text-align: right
        border-right: 1px solid #DEDEDE
</style>



// WEBPACK FOOTER //
// src/components/tool/analysisTable.vue